// Menu Drawer Close Button Handler
document.addEventListener('DOMContentLoaded', function() {
  const closeButton = document.querySelector('.side-menu-close-button');
  const menuDrawer = document.getElementById('menu-drawer');
  const detailsContainer = document.getElementById('Details-menu-drawer-container');
  
  if (closeButton && menuDrawer && detailsContainer) {
    closeButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Hide the menu drawer
      menuDrawer.style.display = 'none';
      
      // Close the details element (removes overlay)
      detailsContainer.removeAttribute('open');
      
      // Optional: Reset display after animation completes
      setTimeout(function() {
        menuDrawer.style.display = '';
      }, 400); // Match this to your CSS transition duration
    });
  }
  
  // Optional: Also close when clicking on the overlay
  detailsContainer.addEventListener('click', function(e) {
    if (e.target === detailsContainer) {
      menuDrawer.style.display = 'none';
      detailsContainer.removeAttribute('open');
      
      setTimeout(function() {
        menuDrawer.style.display = '';
      }, 400);
    }
  });
});